import React from "react";
import SelectInput from "./selectInput";
import TextInputComponent from "./textInputComponent"
import DateTimePickerComponent from "./datetimePickerComponent"
import NumberInputComponent from "./numberInputComponent"
import ToggleComponent from "./toggleComponent"

const inputComponent = props => {
  let inputElement = null;
  switch (props.attributes.elementTypeId) {
    case 1:
      inputElement = (
        <legend className="font-weight-bold text-advanced border-bottom pb-1">
          {props.attributes.label}
        </legend>
      );
      break;
    case 2:
      inputElement = <hr />;
      break;
    case 3:
      if (props.attributes.fieldType === 1) {
        switch (props.attributes.typeCode) {
          case 3:
            inputElement = (
              <ToggleComponent attributes = {props.attributes} />
            );
            break;
          case 15:
            inputElement = (
              <NumberInputComponent attributes = {props.attributes} />             
            );
            break;
          case 16:
            inputElement = (
              <DateTimePickerComponent attributes = {props.attributes} />
            );
            break;
          case 18:            
            inputElement = (
              <TextInputComponent attributes = {props.attributes} />
            );
            break;
            default:
            inputElement = null              
        }        
      } 
      else if (props.attributes.fieldType === 3) {
        return <SelectInput attributes={props.attributes} />;
      }
      break;
    default:
      inputElement = <label>Unknown</label>;
  }

  return inputElement;
};

export default inputComponent;
